import React from 'react';
import { TouchableOpacity } from 'react-native';
import {
  DrawerActions,
  useIsFocused,
  useNavigation,
} from '@react-navigation/native';
import styled from 'styled-components/native';

import Avatar from '@src/components/Avatar';
import Image from '@src/components/Image';
import useProfile from '@src/hooks/useProfile';

const Content = styled.View`
  margin-left: 24px;
`;
const Component: React.FC = () => {
  const navigation = useNavigation();
  const handlePress = React.useCallback(
    () => navigation.dispatch(DrawerActions.toggleDrawer()),
    [navigation]
  );

  const profile = useProfile();

  return (
    <TouchableOpacity onPress={handlePress}>
      {/* //<Content source={require('@src/assets/images/menu.png')} /> */}
      <Content>
        <Avatar
          source={profile?.avatar ?? require('@src/assets/images/avatar.png')}
          size={38}
        />
      </Content>
    </TouchableOpacity>
  );
};

Component.displayName = 'DrawerOpen';

export default React.memo(Component);
